import PropTypes from 'prop-types';
import React from 'react';
import { Checkbox as MCheckbox, FormControlLabel } from '@material-ui/core';

const Checkbox = ({ label, value, onChange }) => (
    <FormControlLabel
        control={
            <MCheckbox
                color="primary"
                checked={value}
                onChange={onChange}
            />
        }
        label={label}
        labelPlacement="end"
    />
);
export default Checkbox;

Checkbox.propTypes = {
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.bool,
};

Checkbox.defaultProps = {
    value: false,
};
